module.exports = __webpack_public_path__ + "static/who-we-are-detail-02.47a53dcb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/who-we-are-detail-02.svg
// module id = 1518
// module chunks = 169858455373905